document.addEventListener('DOMContentLoaded', function() { 



  function complementaryDropdown() {
    // Custom product info dropdown
    let section = document.querySelector('.complementary-dropdown-section');

      if (section) {
        const btn = section.querySelector('.dropdown-initiate');
        const productList = section.querySelector('.horizontal-product-list');
        const maxHeight = section.getAttribute('data-recommendation-height');

        if (btn && productList) {
          btn.addEventListener('click', function() {
            if (section.classList.contains('open')) {
              productList.style.maxHeight = '0';
              section.classList.remove('open');
            } else {
              productList.style.maxHeight = maxHeight + 'px';
              section.classList.add('open');
            }
          });
        }
      }
  }

  function addFooterIcons() {
    if (window.__footerIconsAdded) return;
    window.__footerIconsAdded = true;
    const footer = document.querySelector('.footer__wrapper');
    if (!footer) {
      console.log('Footer wrapper not found');
      return;
    }

    const phoneIcon = `<svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="18" height="18" class="{{ class | strip }}" viewBox="0 0 24 24">
        <path d="M7.102 7.137a2.628 2.628 0 0 0-3.895.421c-.14.192-.312.415-.531.691a4.843 4.843 0 0 0 .007 6.028c1.039 1.287 2.127 2.586 3.343 3.804 1.217 1.217 2.516 2.305 3.805 3.342 1.742 1.406 4.276 1.406 6.026.009.31-.249.554-.432.76-.583 1.237-.903 1.448-2.599.445-3.758a44.912 44.912 0 0 0-1.42-1.542c-.657-.695-1.789-.772-2.512-.144-.125.11-.287.257-.511.464-2-1.188-3.214-2.417-4.382-4.382.213-.226.36-.39.472-.517a1.827 1.827 0 0 0-.148-2.503c-.48-.448-.963-.897-1.459-1.33Z" fill="currentColor" fill-opacity="{% if settings.icon_style == 'duo' %}.12{% else %}0{% endif %}" stroke="currentColor" stroke-linejoin="round"/>
        <path d="M17.297 10.644a4.354 4.354 0 0 0-1.508-2.517 4.354 4.354 0 0 0-2.875-.994M22.59 9.77a9.824 9.824 0 0 0-3.405-5.678 9.828 9.828 0 0 0-6.494-2.246" stroke="currentColor" stroke-linecap="round"/>
      </svg>`;
    const mailIcon = `<svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="18" height="14" class="{{ class | strip }}" viewBox="0 0 18 14">
        <path clip-rule="evenodd" d="M1 2.5A1.5 1.5 0 0 1 2.5 1h13A1.5 1.5 0 0 1 17 2.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 1 11.5v-9Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="m16 2-5.61 4.506c-.82.659-1.96.659-2.78 0L2 2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>`;

    // Helper to insert icon before <a> tag
      function insertIconBeforeLabel(link, iconHTML) {
        const parent = link.parentNode;
        let prev = link.previousSibling;
        // Only proceed if previous sibling is a text node
        if (prev && prev.nodeType === Node.TEXT_NODE && prev.textContent.trim() !== '') {
          // Create icon span
          const iconSpan = document.createElement('span');
          iconSpan.innerHTML = iconHTML;
          iconSpan.style.marginRight = '5px';
          // Insert icon before the text node
          parent.insertBefore(iconSpan, prev);
        }
      }

      footer.querySelectorAll('a[href^="tel:"]').forEach(link => {
        insertIconBeforeLabel(link, phoneIcon);
      });

      footer.querySelectorAll('a[href^="mailto:"]').forEach(link => {
        insertIconBeforeLabel(link, mailIcon);
      });
  }
  

  // Check for cookies when the page loads
  window.onload = function() {
    
    setTimeout(function() {
      complementaryDropdown();
      addFooterIcons();
    }, 500);
  };


    //Custom drop function
    let produktudvikling = document.querySelector('.produktudvikling-drop img'),
    produktion = document.querySelector('.produktion-drop img'),
    raadgivning = document.querySelector('.raadgivning-drop img'),
    produktudviklingText = document.querySelector('.produktudvikling-d'),
    produktionText = document.querySelector('.produktion-d'),
    raadgivningText = document.querySelector('.raadgivning-d');

    if (produktudvikling && produktion && raadgivning) {
    produktudvikling.addEventListener('mouseenter', function(){
        produktionText.classList.remove('active-text');
        raadgivningText.classList.remove('active-text');
        produktudviklingText.classList.add('active-text');
    })
    produktudvikling.addEventListener('click', function(){
        produktionText.classList.remove('active-text');
        raadgivningText.classList.remove('active-text');
        produktudviklingText.classList.add('active-text');
    })

    produktion.addEventListener('mouseenter', function(){
        produktudviklingText.classList.remove('active-text');
        raadgivningText.classList.remove('active-text');
        produktionText.classList.add('active-text');
    })
    produktion.addEventListener('click', function(){
        produktudviklingText.classList.remove('active-text');
        raadgivningText.classList.remove('active-text');
        produktionText.classList.add('active-text');
    })

    raadgivning.addEventListener('mouseenter', function(){
        produktudviklingText.classList.remove('active-text');
        produktionText.classList.remove('active-text');
        raadgivningText.classList.add('active-text');
    })
    raadgivning.addEventListener('click', function(){
        produktudviklingText.classList.remove('active-text');
        produktionText.classList.remove('active-text');
        raadgivningText.classList.add('active-text');
    }) }

    // Custom contact for order function in cart page
    setTimeout(function(){
        let inputDestination = document.querySelector('.hidden-product-inputs');
     if (inputDestination) {
        let productSummary = document.querySelector('.order-summary__body'),
        products = productSummary.querySelectorAll('tr'),
        index = 0;
        products.forEach(function (product){
            index = index + 1;
            let title = product.querySelector('.line-item__info .reversed-link').textContent,
            quantity = product.querySelector('line-item-quantity input').value;
            let price;
            if (product.querySelector('.total-price-custom .money.withVat')) {
              price = product.querySelector('.total-price-custom .money.withVat').textContent;
            } else if (product.querySelector('.total-price-custom .money')) {
              price = product.querySelector('.total-price-custom .money').textContent;
            } else {
              price = product.querySelector('.hiddenPriceSverige').textContent;
            }
            let variant;
            if (product.querySelector('.custom-variant-title')) {
              variant = product.querySelector('.custom-variant-title').textContent;
            }
            let inputField = document.createElement('input');
            inputField.type = 'text';
            inputField.classList.add('input', 'is-floating');
            inputField.name = 'contact[produkt ' + index + ']';
            if (product.querySelector('.custom-variant-title')) {
              inputField.value = title + ' - Variant: '+ variant + ' - Antal: ' + quantity + ' - Pris: ' + price;
            } else {
              inputField.value = title + ' - Antal: ' + quantity + ' - Pris: ' + price;
            }
            inputDestination.appendChild(inputField);
        });
    }
    
      
      
    
    },500)
    
    // Custom variant data and files swatches
    let variantPicker = document.querySelector('.product-info__variant-picker');
    if (variantPicker) {
        let variantOptions = variantPicker.querySelectorAll('label.block-swatch');
        variantOptions.forEach(function(variantOption){
            let textCheck = variantOption.querySelector('span').textContent;
            variantOption.addEventListener('click', function(){
              let userType = getCookie('userType');
              if (userType == 'Erhvervskunde') {
                handleErhvervskunde();
              }
                let dataLists = document.querySelectorAll('.variant-documents');
                dataLists.forEach(function(dataList){
                    let dataCheck = dataList.getAttribute('id');
                    dataList.classList.remove('active');
                    if (textCheck == dataCheck) {
                        dataList.classList.add('active');
                    }
                })
                let klimaList = document.querySelectorAll('.product-info__climate-impact_variant');
                if (klimaList) {
                    klimaList.forEach(function(klima){
                        let klimaCheck = klima.getAttribute('id');
                        klima.classList.remove('active');
                        if (textCheck == klimaCheck) {
                            klima.classList.add('active');
                        }
                    })
                };
            })
        })
    }

    
    var arrows = document.querySelectorAll('.scroll-arrow-to-next-section');
    if (arrows && arrows.length > 0) {
      arrows.forEach(function(arrow) {
        arrow.addEventListener('click', function() {
          var nextSection = arrow.closest('section').nextElementSibling;
          if (nextSection) {
            nextSection.scrollIntoView({ behavior: 'smooth' });
          }
        });
      });
    }



    var openBtn = document.querySelector('.update-contact');
  var modal = document.getElementById('contact-form-modal');
  var closeBtn = document.getElementById('close-contact-modal');

  if (openBtn && modal && closeBtn) {
    openBtn.addEventListener('click', function() {
      modal.style.display = 'block';
    });

    closeBtn.addEventListener('click', function() {
      modal.style.display = 'none';
    });

    window.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });
  }

});

